export default __webpack_public_path__ + "static/media/mes-campagnes.a262e689.svg";